import { Component, OnInit } from '@angular/core';
import { ChartsService } from 'src/app/services/charts.service';

export class PushedRegion {
  constructor(public region : string, public share: number) {}
}

@Component({
  selector: 'app-charts-pushed-chart',
  templateUrl: './charts-pushed-chart.component.html',
  styleUrls: ['./charts-pushed-chart.component.scss']
})
export class ChartsPushedChartComponent implements OnInit {

  constructor(private chartsService : ChartsService) { }
  totalPushes = 0;
  chartData : PushedRegion[] = [];
  isLoading = true;

  ngOnInit(): void {
    this.chartsService.getDealersPushedToByUserByRegion().subscribe((res : any[]) => {
      res.forEach((r) => this.totalPushes += r.pushCount);
      for (let region of res) {
        if (region.region) {
          this.chartData.push(new PushedRegion(region.region.replace('REGION', this.formatPercentage(region.pushCount)), region.pushCount / this.totalPushes ));
        }
      }
      this.isLoading = false;
    })
  }
  public formatPercentage(num) : string {
    return Math.round((((num / this.totalPushes) * 100) * 100)) / 100 + "%"; // looks weird, but works
  }

  public labelContent(e: any): string {
    return e.category + '/n';
  }

}
